import React from "react";

const ScreenSharePlayer = ({ screenTrack, width = "100%", height = "100%" }) => {
  const videoRef = React.useRef(null);

  React.useEffect(() => {
    if (screenTrack && videoRef.current) {
      screenTrack.play(videoRef.current);
    }
    return () => {
      if (screenTrack) {
        screenTrack.stop();
      }
    };
  }, [screenTrack]);

  return <div ref={videoRef} style={{ width, height, background: "#000" }} />;
};

export default ScreenSharePlayer;
